const getQueryParameterByName = require('../helpers/GetQueryParam');

const ppFlagFromUri = getQueryParameterByName('ppflag');
const ppFlag = ppFlagFromUri ? !!parseInt(ppFlagFromUri) : undefined;

const ppFlagActiveFromUri = getQueryParameterByName('ppflag_active');
const ppFlagActive = ppFlagActiveFromUri ? !!parseInt(ppFlagActiveFromUri) : undefined;

const localeMap = {
  en: 'en_US',
  fr: 'fr_CA',
  en_US: 'en_US',
  fr_CA: 'fr_CA'
};

// Function to get value by key
function getLocaleValue(key) {
  if (localeMap.hasOwnProperty(key)) {
      return localeMap[key];
  }
  return key; // Just for testing...in production it is en_US by default
}

const DevLoader = {
  productId: getQueryParameterByName('ucid'),
  schoolCode: getQueryParameterByName('schoolcode'),
  configId: getQueryParameterByName('uc_configid'),
  ln: getLocaleValue(getQueryParameterByName('lang') || getQueryParameterByName('ln') || 'en'),
  ppFlag,
  ppFlagActive,
};

export default DevLoader;


// WEBPACK FOOTER //
// ./src/base/scripts/loaders/dev.js